/* <sst-header>: rotating announcements, solid-on-scroll overlay, menu drawer. */
if (!customElements.get('sst-header')) {
  customElements.define(
    'sst-header',
    class extends HTMLElement {
      connectedCallback() {
        this.initAnnouncements();
        this.initDrawer();
        this.initSearch();

        if (this.classList.contains('sst-header--overlay')) {
          const update = () => this.classList.toggle('is-solid', window.scrollY > 40);
          window.addEventListener('scroll', update, { passive: true });
          update();
        }
      }

      initAnnouncements() {
        const bar = this.querySelector('.sst-announcement');
        this.messages = [...this.querySelectorAll('.sst-announcement__message')];
        if (!bar || this.messages.length < 2) return;

        this.index = 0;
        bar.querySelectorAll('[data-announcement]').forEach((btn) =>
          btn.addEventListener('click', () => {
            this.step(Number(btn.dataset.announcement));
            this.startRotation(bar);
          })
        );
        bar.addEventListener('mouseenter', () => clearInterval(this.timer));
        bar.addEventListener('mouseleave', () => this.startRotation(bar));
        this.startRotation(bar);
      }

      startRotation(bar) {
        clearInterval(this.timer);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => this.step(1), Number(bar.dataset.interval) || 5000);
      }

      step(dir) {
        this.messages[this.index].hidden = true;
        this.index = (this.index + dir + this.messages.length) % this.messages.length;
        this.messages[this.index].hidden = false;
      }

      initSearch() {
        const dialog = this.querySelector('.sst-search');
        const opener = this.querySelector('[data-search-open]');
        if (!dialog || !opener) return;

        opener.addEventListener('click', () => {
          dialog.showModal();
          dialog.querySelector('input[type="search"]').focus();
        });
        dialog.querySelector('[data-search-close]').addEventListener('click', () => dialog.close());
        // Backdrop clicks target the <dialog> itself, outside the panel.
        dialog.addEventListener('click', (e) => {
          if (e.target === dialog) dialog.close();
        });
      }

      initDrawer() {
        const drawer = this.querySelector('.sst-drawer');
        const opener = this.querySelector('[data-drawer-open]');
        if (!drawer || !opener) return;

        opener.addEventListener('click', () => drawer.showModal());
        drawer.querySelector('[data-drawer-close]')?.addEventListener('click', () => drawer.close());
        // Backdrop clicks target the <dialog> itself and land right of the panel.
        drawer.addEventListener('click', (e) => {
          if (e.target === drawer && e.clientX > drawer.getBoundingClientRect().right) drawer.close();
        });
      }
    }
  );
}
